import Countdown from '../countdown'
import AUDIO,{ AUDIO_STORE, AUDIO_STATUS } from '@/data/audio'
import { getCurrentPath } from '@/common/utils/route.js'

export default {
    data () {
        return {
            audio_playing_index: -1,
            audio_playing: [],
            durations: [],
            running_times: [],
            _current_route: '',
            time_task: 0,
            audio_url: ''
        }
    },
    mounted() {
        this.initAudio()
    },
    onLoad () {
        this.initAudio()
    },
    onUnload () {
        this.resetAudio()
    },
    beforeDestroy () {
        this.resetAudio()
    },
    methods: {
        initAudio() {
            AUDIO.initAudio()
            this.initCurrentRoute()
            this.addListener()
        },
        resetAudio() {
            this.stopPlaying()
            this.removeListener()
            if (this.audio_playing.includes(true)) {
                AUDIO.resetRunningTime()
            }
        },
        initCurrentRoute() {
            this._current_route = 'img_' + new Date().getTime()
        },
        addListener() {
            AUDIO_STORE.add_status_watcher(this._current_route, (status)=> {
                if (status === AUDIO_STATUS.PLAYING) {
                    this.audio_playing= this.audio_playing.map(() => {
                        return false
                    })
                    this.$set(this.audio_playing, this.audio_playing_index, true)
                    AUDIO.runClock()
                    const { building_id, title } = this.$route.query
                    const building_name = this.title || title || ''
                    Countdown.play(this.audio_url, {
                        building_id,
                        building_name: building_name.replace('-户型图', '')
                    })
                }
                else if (status === AUDIO_STATUS.STOP) {
                    this.audio_playing= this.audio_playing.map(() => {
                        return false
                    })
                    AUDIO.stopRunningTime()
                    Countdown.stop()
                } else {
                    this.resetRunningTime(0)
                    Countdown.stop()
                }
            })
            AUDIO_STORE.add_duration_watcher(this._current_route, (duration)=> {
                this.$set(this.durations, this.audio_playing_index, duration)
            })
            AUDIO_STORE.add_running_time_watcher(this._current_route, (running_time)=> {
                this.$set(this.running_times, this.audio_playing_index, running_time)
            })
        },
        removeListener() {
            AUDIO_STORE.remove_status_watcher(this._current_route)
            AUDIO_STORE.remove_duration_watcher(this._current_route)
            AUDIO_STORE.remove_running_time_watcher(this._current_route)
        },
        stopPlaying() {
            if (this.audio_playing.includes(true)) {
                AUDIO.stopAudio()
                AUDIO.stopRunningTime()
            }
        },
        playAudio (index, audio_url) {
            this.audio_playing_index = index
            this.audio_url = audio_url
            AUDIO.playAudio(audio_url,this.title,this.running_times[index])
        },
        stopAudio (index) {
            AUDIO.stopAudio()
            this.$set(this.audio_playing, index, false)
        },
        resetAudioPlaying (urls = []) {
            this.audio_playing = urls.map(() => false)
        },
        seekAudio (percent) {
            AUDIO.seekAudio(percent)
        },
        resetRunningTime (running_time = 0) {
            console.error('resetRunningTime', this.audio_playing_index, running_time)
            AUDIO.stopRunningTime()
            this.resetAudioPlaying()
            if (this.audio_playing_index > -1) {
                this.$set(this.running_times, this.audio_playing_index, running_time)
            }
        }
    }
}